import Vue from 'vue';
import { themeStore } from '@/stores/themeStore';
export default Vue.extend({
    name: 'SettingsMenu',
    data() {
        return {
            menuOpen: false,
        };
    },
    computed: {
        isDark() {
            return themeStore.isDark;
        },
    },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        closeMenu() {
            this.menuOpen = false;
        },
        toggleTheme() {
            themeStore.toggleTheme();
        },
    },
});
